import script from "./GuidedTargetsPdf.vue?vue&type=script&setup=true&lang=js"
export * from "./GuidedTargetsPdf.vue?vue&type=script&setup=true&lang=js"

import "./GuidedTargetsPdf.vue?vue&type=style&index=0&id=d96fff9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d96fff9a"]])

export default __exports__